import { render, staticRenderFns } from "./requestsModal.vue?vue&type=template&id=fcde65c0"
import script from "./requestsModal.vue?vue&type=script&lang=js"
export * from "./requestsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports